@import (less) "./less/responsive.less";

/* stylelint-disable @stylistic/property-case */

:export {
  desktopWidth: @screen-desktop;
  maxMobileWidth: @screen-phone-max;
  tabletWidth: @screen-tablet;
}

/* stylelint-enable @stylistic/property-case */
